import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { AppStore } from 'src/app/store/store.model';
import { LoadOrganizationProfile } from 'src/app/store/user/user.actions';
import { getOrganizationProfile, getUserRequestError } from 'src/app/store/user/user.selectors';
import { first, mapTo } from 'rxjs/operators';
import { race } from 'rxjs';
import { Organization } from 'src/app/admin/models/organization.model';

@Injectable()
export class OrganizationProfileResolver {
  constructor(private store: Store<AppStore>) {}

  public resolve() {
    this.store.dispatch(LoadOrganizationProfile());

    const loaded$ = this.store.select(getOrganizationProfile).pipe(first(Boolean));

    const errored$ = this.store.select(getUserRequestError).pipe(first(Boolean), mapTo(null));

    return race<Organization, null>(loaded$, errored$);
  }
}
